<div class="w-full px-4 py-3">
  <div class="bg-white rounded-md  border-2 border-blue-900 border-gray-300 px-4 py-2 sm:p-6 mb-4">
    <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
    <div class="flex gap-3">
    
      <div class="flex-1">
        <h4 class="text-xl sm:text-2xl font-bold text-slate-800 mb-1">
          {{stepDetails?.name}}
        </h4>
    
        <h5 class="text-base sm:text-lg text-blue-600 font-semibold mb-3">
          [{{ payload?.proposal_name }}]
        </h5>
    
    
      </div>
      <div>
        
        <span class="inline-flex items-center px-3 py-1.5 border-2 rounded-full text-sm font-bold transition-all" [ngClass]="{
                        'bg-slate-100 text-slate-700 border border-slate-500': stepDetails?.step_status == 0,
                        'bg-emerald-100 text-emerald-700 border border-emerald-500': stepDetails?.step_status == 'approved',
                        'bg-amber-100 text-amber-700 border border-amber-500': stepDetails?.step_status == 'recommended',
                        'bg-blue-100 text-blue-700 border border-blue-500': stepDetails?.step_status == 'initiated'
                      }">
          <span class="w-2 h-2 rounded-full mr-2 animate-pulse" [ngClass]="{
                          'bg-slate-500': stepDetails?.step_status == 0,
                          'bg-emerald-500': stepDetails?.step_status == 'approved',
                          'bg-amber-500': stepDetails?.step_status == 'recommended',
                          'bg-blue-500': stepDetails?.step_status == 'initiated'
                        }"></span>
          {{ stepDetails?.step_status == 0 ? " PENDING" : (stepDetails?.step_status | uppercase) }}
        </span>
      </div>
    </div>

      <!-- Action Buttons -->
      <div class="flex flex-wrap items-center gap-2">

        <ng-container *ngIf="stepDetails?.can_edit">
          <button (click)="routeConfig.emit({isRouteConfig: true})"  class="inline-flex items-center px-4 py-2.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:bg-slate-300 disabled:cursor-not-allowed transition-all duration-200 font-medium text-sm shadow-sm hover:shadow-md">
            <i class="pi pi-save mr-2"></i> Save/Forward/Route Config
          </button>
        </ng-container>
      </div>
    </div>
  </div>
   <div class="mb-4">
   

  <hr class="my-3 border-gray-200" />

  <ng-container *ngIf="!['tdf','makeI','makeII','makeIII'].includes(schemeType)">
    <h5 class="mt-4 text-base font-semibold text-gray-800">Uploaded Final SOTR</h5>
    <ul *ngIf="needGenData?.draft_sotr" class="list-disc ml-6 mb-2">
      <li>
        <a 
          [href]="apiUrl + needGenData?.draft_sotr"
          target="_blank" 
          rel="noopener noreferrer"
          class="text-blue-600 hover:underline"
        >
          {{getFileName(needGenData?.draft_sotr)}}
        </a>
      </li>
    </ul>
    <ul *ngIf="needGenData?.upload_photograph" class="list-disc ml-6 mb-2">
      <li>
        <a 
          [href]="apiUrl + needGenData?.upload_photograph"
          target="_blank" 
          rel="noopener noreferrer"
          class="text-blue-600 hover:underline"
        >
          {{getFileName(needGenData?.upload_photograph)}}
        </a>
      </li>
    </ul>
  </ng-container>

  <ng-container *ngIf="!['tdf','makeI','makeII','makeIII'].includes(schemeType)">
    <h5 class="mt-4 text-base font-semibold text-gray-800">Uploaded in previous steps Supporting Documents</h5>
    <ul *ngIf="needGenData?.need_files" class="list-disc ml-6 mb-2">
      <li *ngFor="let file of needGenData?.need_files">
        <a 
          [href]="apiUrl + file.file"
          target="_blank" 
          rel="noopener noreferrer"
          class="text-blue-600 hover:underline"
        >
          {{getFileName(file.file)}}
        </a>
      </li>
    </ul>
    <ul *ngIf="needGenData?.feasibility_study" class="list-disc ml-6 mb-2">
      <li>
        <a 
          [href]="apiUrl + needGenData?.feasibility_study"
          target="_blank"
          rel="noopener noreferrer"
          class="text-blue-600 hover:underline"
        >
          {{getFileName(needGenData?.feasibility_study)}}
        </a>
      </li>
    </ul>
    <ul *ngIf="needGenData?.needmake_files" class="list-disc ml-6 mb-2">
      <li *ngFor="let file of needGenData?.needmake_files">
        <a 
          [href]="apiUrl + file.file"
          target="_blank" 
          rel="noopener noreferrer"
          class="text-blue-600 hover:underline"
        >
          {{getFileName(file.file)}}
        </a>
      </li>
    </ul>
  </ng-container>

  <div class="p-3">
    <app-upload-document 
      [title]="'Feasibility Study Document'" 
      [isEditable]="stepDetails?.can_edit">
    </app-upload-document>
  </div>

  <div>
    <div class="p-3" *ngIf="commentForm">
      <form [formGroup]="commentForm">
        <div>
          <label class="block font-medium mb-1 bg-blue-500 text-white p-2 rounded-md">
            Feasibility Study Format <span class="text-orange-500">*</span>
          </label>
          <div>
            <editor 
              [init]="init" 
              formControlName="comment"  
              [disabled]="isEditorDisabled"
              placeholder="Type your justification here..."
              class="w-full"
            >
            </editor>
          </div>
          
        </div>
      </form>
    </div>
    
  </div>
</div>
